<script lang="ts">
  import PdfLogo from "$assets/icons/fileTypes/file-type-pdf2.svelte";
  import DocLogo from "$assets/icons/fileTypes/file-type-word.svelte";
  import PptLogo from "$assets/icons/fileTypes/file-type-powerpoint.svelte";
  import TxtLogo from "$assets/icons/fileTypes/file-txt-o.svelte";
  import XlsLogo from "$assets/icons/fileTypes/file-type-excel.svelte";
  import type { SecurityFinding } from "$lib/stores/orgSecurityFindings";
  import { SecurityFindingKind } from "$lib/models/base";
  import SharepointConnection from "$assets/icons/sharepoint-connection.svelte";
  import FoundSecurityFinding from "$assets/icons/found-security-finding.svelte";
  import MicrosoftLogo from "$assets/icons/microsoft-logo.svelte";
  import GoogleLogo from "$assets/icons/google-logo.svelte";
  import Sharepoint from "$assets/icons/sharepoint.svelte";

  let { finding, showProvider = false } = $props<{ finding: SecurityFinding; showProvider?: boolean }>();

  const extension = $derived(finding.resources[0]?.name?.split(".").pop()?.toLowerCase());
  const isDocumentBasedFinding = $derived(
    finding.securityFindingKind === SecurityFindingKind.PUBLIC_DOCUMENT ||
      finding.securityFindingKind === SecurityFindingKind.ANOMALOUS_PERMISSIONS_ON_SENSITIVE_DOCUMENT ||
      finding.securityFindingKind === SecurityFindingKind.DOCUMENT_ACCESSED_BY_EXTERNAL_PRINCIPAL,
  );
  const isConnectionBasedFinding = $derived(
    finding.securityFindingKind === SecurityFindingKind.LARGE_SCALE_COLLABORATION_ON_PERSONAL_DRIVE ||
      finding.securityFindingKind === SecurityFindingKind.PERSONAL_DRIVE_WITH_SENSITIVE_DOCUMENTS ||
      finding.securityFindingKind === SecurityFindingKind.PERMISSIONS_MANAGED_THROUGH_SECONDARY_IDENTITY,
  );
</script>

<div class="w-12 h-12 rounded-full bg-gray-200 border-2 border-white flex items-center justify-center">
  <span class="w-8 h-8 relative">
    {#if isDocumentBasedFinding}
      {#if extension === "pdf"}
        <PdfLogo />
      {:else if ["doc", "docx"].includes(extension ?? "")}
        <DocLogo />
      {:else if ["xls", "xlsx"].includes(extension ?? "")}
        <XlsLogo />
      {:else if ["ppt", "pptx"].includes(extension ?? "")}
        <PptLogo />
      {:else if extension === "txt"}
        <TxtLogo />
      {:else}
        <!-- Default document icon for unknown extensions -->
        <TxtLogo />
      {/if}
    {:else if isConnectionBasedFinding}
      <div class="p-1 text-gray-500">
        <SharepointConnection />
      </div>
    {:else}
      <div class="p-1 text-gray-500">
        <FoundSecurityFinding />
      </div>
    {/if}

    {#if showProvider}
      <div class="w-5 relative -top-2 -left-2 bg-white rounded-full p-0.5 m-0.5">
        {#if finding.system === "msgraph-v4"}
          <Sharepoint />
        {:else if finding.system === "google-drive-v1.0.0"}
          <GoogleLogo />
        {/if}
      </div>
    {/if}
  </span>
</div>
